import { ABHA_QR } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export default (clinicId: string): Promise<ArrayBuffer> => {
    return fetchWithRefresh(ABHA_QR(clinicId), {
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.arrayBuffer();
        } else {
            throw new Error('failed to fetchABHAQr');
        }
    });
};
